var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBookingAssigned = function SvgBookingAssigned(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 17.25C11.25 18.8413 11.8821 20.3674 13.0074 21.4926C14.1326 22.6179 15.6587 23.25 17.25 23.25C18.8413 23.25 20.3674 22.6179 21.4926 21.4926C22.6179 20.3674 23.25 18.8413 23.25 17.25C23.25 15.6587 22.6179 14.1326 21.4926 13.0074C20.3674 11.8821 18.8413 11.25 17.25 11.25C15.6587 11.25 14.1326 11.8821 13.0074 13.0074C11.8821 14.1326 11.25 15.6587 11.25 17.25Z",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 14.25V20.25",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 17.25H20.25",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37585 4.98584V5.98584C3.41503 7.13697 3.11642 8.2744 2.51685 9.25784",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.623 4.98584V5.98584C11.5841 7.13707 11.8831 8.27451 12.483 9.25784",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38818 5.19969C4.169 5.19483 4.93977 5.02325 5.64892 4.69645C6.35807 4.36964 6.98924 3.89513 7.50019 3.30469C8.01067 3.89605 8.64163 4.37149 9.35081 4.69917C10.06 5.02685 10.831 5.19921 11.6122 5.20469",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 4.875C3.375 5.96902 3.8096 7.01823 4.58318 7.79182C5.35677 8.5654 6.40598 9 7.5 9C8.59402 9 9.64323 8.5654 10.4168 7.79182C11.1904 7.01823 11.625 5.96902 11.625 4.875C11.625 3.78098 11.1904 2.73177 10.4168 1.95818C9.64323 1.1846 8.59402 0.75 7.5 0.75C6.40598 0.75 5.35677 1.1846 4.58318 1.95818C3.8096 2.73177 3.375 3.78098 3.375 4.875V4.875Z",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 17.2499C0.75076 16.134 1.02804 15.0356 1.55706 14.0531C2.08607 13.0705 2.85033 12.2344 3.78149 11.6195C4.71265 11.0045 5.7817 10.6299 6.89305 10.5291C8.00439 10.4283 9.12339 10.6045 10.15 11.0419",
    stroke: "#8290A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBookingAssigned, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/booking-assigned.6c03ef03.svg";
export { ForwardRef as ReactComponent };